(function () {
    'use strict';

    angular
        .module('ActionManager')
        .factory('action-dom-func-call', actionFunc);

    function actionFunc($q, lodash) {
        return function(options, actionData, eventData) {
            return $q.when(run());
            function run() {
                let target = null;
                if (lodash.get(options, 'parent' ,false)) {
                    const parent = angular.element(options.parent_dom);
                    if (parent.length > 0) {
                        target = parent.find(options.dom);
                    }
                } else {
                    target = angular.element(options.dom);
                }

                if (target !== null && target.length > 0) {
                    // target.addClass(options.class_to_add);
                    const func_name = lodash.get(options, 'func_name', null);
                    if (!func_name) {
                        return false;
                    }
                    target[func_name]();
                }
                return true;
            }
        };
    }
})();